import { apiInstance3 } from "@app/utils/api";
import { AxiosResponse } from "axios";

export const retrieveData: any = (res: AxiosResponse<any>) => {
  if (Object.prototype.hasOwnProperty.call(res, "data")) {
    return retrieveData(res.data);
  }
  return res;
};

export const tenantInfoApi = async (headerConfigObj = {}) => {
  const res = await apiInstance3.get("integrations/tenant/tenantInfo", {
    headers: {
      ...headerConfigObj
    }
  });
  return retrieveData(res);
};

export const getTenantInfo = async (headerConfigObj = {}) => {
  if (typeof window !== "undefined") {
    const tenantInfo = sessionStorage.getItem("tenantInfo");
    if (tenantInfo) {
      return JSON.parse(tenantInfo);
    }
    const data = await tenantInfoApi();
    sessionStorage.setItem("tenantInfo", JSON.stringify(data));
    return data;
  }
  const data = await tenantInfoApi(headerConfigObj);
  return data;
};
